import { useNavigate } from 'react-router-dom';
import { AppShell } from '../app/AppShell';
import { useSpaces } from '../api/hooks';
import { IconChevron } from '../components/icons';
import { Badge, Card, EmptyState, ErrorText, Spinner } from '../components/ui';
import { zh } from '../i18n';
import { formatBytes, formatRelative } from '../lib/format';

/**
 * 共享空間 list (CONTRACTS §4.6). `none` grants never appear — the server omits
 * them — so this screen shows exactly what the caller may open, and the `ro`/`rw`
 * badge is the same level the kernel enforces on the runner's mounts.
 */
export function SpacesRoute(): JSX.Element {
  const spaces = useSpaces();
  const navigate = useNavigate();

  return (
    <AppShell>
      <div className="page-head">
        <h1 className="page-head__title">{zh.spaces.title}</h1>
      </div>

      {spaces.isLoading ? <Spinner /> : null}
      <ErrorText error={spaces.error} />

      {spaces.data && spaces.data.length === 0 ? (
        <EmptyState title={zh.spaces.empty} body={zh.spaces.emptyHint} />
      ) : null}

      {spaces.data && spaces.data.length > 0 ? (
        <Card flush>
          <ul className="list">
            {spaces.data.map((space) => (
              <li key={space.slug}>
                <button
                  type="button"
                  className="list__row"
                  onClick={() => navigate(`/spaces/${space.slug}`)}
                >
                  <div className="list__main">
                    <div className="list__title">{space.name}</div>
                    <div className="list__sub">
                      {space.kind === 'company' ? zh.spaces.kindCompany : zh.spaces.kindDepartment}
                      {space.lastCommitAt !== null
                        ? ` · ${zh.spaces.lastCommit(formatRelative(space.lastCommitAt))}`
                        : ''}
                      {space.sizeBytes !== null
                        ? ` · ${zh.spaces.sizeLabel(formatBytes(space.sizeBytes))}`
                        : ''}
                    </div>
                  </div>
                  <Badge tone={space.level === 'rw' ? 'success' : 'muted'}>
                    {space.level === 'rw' ? zh.spaces.levelRw : zh.spaces.levelRo}
                  </Badge>
                  <IconChevron size={16} className="tool__icon" />
                </button>
              </li>
            ))}
          </ul>
        </Card>
      ) : null}
    </AppShell>
  );
}
